import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import AppTheme from './theme';
import { routes } from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {MessageService} from 'primeng/api';
import {ErrorInterceptor} from './interceptors/error-handler';
import {AuthInterceptor} from './interceptors/auth.interceptor';
import {BaseUrlInterceptor} from './interceptors/http_interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: AppTheme,
      ripple: true,
      translation: {
        startsWith: 'Inizia con',
        contains: 'Contiene',
        notContains: 'Non contiene',
        endsWith: 'Finisce con',
        equals: 'Uguale a',
        notEquals: 'Diverso da',
        noFilter: 'Nessun filtro',
        lt: 'Minore di',
        lte: 'Minore o uguale a',
        gt: 'Maggiore di',
        gte: 'Maggiore o uguale a',
        is: 'È',
        isNot: 'Non è',
        before: 'Prima',
        after: 'Dopo',
        dateIs: 'Data uguale a',
        dateIsNot: 'Data diversa da',
        dateBefore: 'Data prima di',
        dateAfter: 'Data dopo',
        clear: 'Cancella',
        apply: 'Applica',
        matchAll: 'Tutti i criteri',
        matchAny: 'Almeno un criterio',
        addRule: 'Aggiungi regola',
        removeRule: 'Rimuovi regola',
        accept: 'Sì',
        reject: 'No',
        choose: 'Scegli',
        upload: 'Carica',
        cancel: 'Annulla',
        emptyMessage: 'Nessun risultato',
        emptyFilterMessage: 'Nessun risultato trovato',
        searchMessage: '{0} risultati disponibili',
        selectionMessage: '{0} elementi selezionati',
        emptySelectionMessage: 'Nessun elemento selezionato',
        emptySearchMessage: 'Nessun risultato trovato',
      },
    }),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    MessageService,
  ]
};
